import React, { Component } from 'react';

class Footer extends Component {
  render() {

    if(this.props.data){
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
              {networks}
           </ul>

           <ul>
            <li>Modified with love by NoobCoder24/7 ♥️</li>
           </ul>

           <ul className="copyright">
              <li>&copy; All credit goes to NoobCoder24 - Copyright 2020</li>
              <li>Design by <a title="NoobCoder24" href="http://www.thenoobcoder.ml/">NoobCoder24</a></li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
    );
  }
}

export default Footer;
